import type { JSX } from 'react';
import { SpeakersGrid } from '~/components/SpeakerBios/SpeakersGrid';
import { useSpeakers } from '~/singlePageApp/hooks/speakers/useSpeakers';
import { isNil } from '~/utilities/type-guards';

type SpeakerBiosProps = {
  mediaHashedId: string;
};

const SpeakerBiosImpl = ({ mediaHashedId }: Required<SpeakerBiosProps>): JSX.Element | null => {
  const { speakers } = useSpeakers({
    mediaHashedId,
  });

  return <SpeakersGrid speakers={speakers} />;
};

export const SpeakerBios = ({ mediaHashedId }: SpeakerBiosProps): JSX.Element | null => {
  if (isNil(mediaHashedId)) {
    return null;
  }

  return <SpeakerBiosImpl mediaHashedId={mediaHashedId} />;
};
